import React, { useMemo } from "react";
import { isStartListStatus, isLiveStatus } from "helpers/status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import Status from "components/presentation/Status";

//Without Block start and 800 no Road Races
import { TableColumns as ColumnsStart, TableColumnsSM as ColumnsStartSM } from 'components/sports/mtb/events/start/Columns'

import { TableColumns as ColumnsResLive } from 'components/sports/mtb/events/results/ColumnsLive'
import { TableColumnsSM as ColumnsResLiveSM } from 'components/sports/mtb/events/results/ColumnsLive'

import { TableColumns as ColumnsRes, TableColumnsSM as ColumnsResSM } from 'components/sports/mtb/events/results/ColumnsFinish'
import { TableExpanded } from 'components/sports/mtb/events/results/TableExpanded'
import { hasConfig } from "components/sports/mtb/helper/MtbHelpers"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'

//Race Info
import MtbRaceInfo from 'components/sports/mtb/views/MtbRaceInfo'
import PhotoFinish from "components/general/PhotoFinish";



const getConfiguration = (data, resultStatus, breakPoint, caption) => {

    //determinar si la configuacion viene del config o del result depende del deporte
    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []
    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false


    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartList,
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    configuration.caption = <CaptionTable
        leftCol={<>{caption}</>}
        rightCol={<Status typeToPrint='result' scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartList
        ? [{ id: 'Bib', desc: false }]
        : isLive
            ? [{ id: 'RankIntermediate', desc: false }]
            : [{ id: 'Rank', desc: false }]

    configuration.filters = {
        ei_type: ['DISPLAY'],
        ei_code: ['INTERMEDIATE_CURRENT']
    };


    configuration.columns = isStartList
        ? breakPoint === "sm" || breakPoint === "xs"
            ? ColumnsStartSM(columnsAdded)
            : ColumnsStart(columnsAdded)
        : isLive
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsResLiveSM(columnsAdded)
                : ColumnsResLive(columnsAdded)
            : breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsResSM(columnsAdded)
                : ColumnsRes(columnsAdded);
    return configuration;
};


const MtbResults = ({ data, caption }) => {
    const { mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;


    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, resultStatus, breakPoint, caption), [resultStatus, breakPoint]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} config={configEvent.configs.columnsAdded} />
        }
        />
        // eslint-disable-next-line
    ), [resultStatus]);


    const items = data?.results?.items
    const showAll = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    //const showAllresultAnalysis = items?.some(item => item?.resultAnalysis?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    const hasConfiguration = hasConfig(configEvent.configs.columnsAdded)

    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []
    if (!showAll && !hasConfiguration) hiddenColumns.push('Expander')
    return (
        <>
            {data?.results ? (
                <>
                    {// PhotoFinish funcionará para Krakow23
                        mirs_competition === 'EG2023' ? <PhotoFinish data={data?.images} /> : ''}
                    {data?.results?.items ? (
                        < MirsTable
                            className='table-result'
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //subcomponente a renderizar, extended
                            renderRowSubComponent={renderRowSubComponent}
                            //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente                             
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Splits to show
                            //current split (initial)
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            //Show buttons move to splits 
                            showNavExtendedData={true}
                            id={`mirs-table-result-${mirs_rsc}`}
                            hasRelatedTimeline={true}
                        />
                    ) : ('')
                    }

                </>
            ) : (
                <span><em>No data available</em></span>
            )
            }
            {data?.config ? (
                <MtbRaceInfo config={data.config} />
            ) : ""}
        </>
    );
};

export default MtbResults;
